<template>
  <v-layout style="position: relative" class="fill-height">
    <v-row class="secondary">
      <v-col cols="12">
        <v-row class="select--field" justify="center">
          <v-col cols="7" md="3">
            <v-select
              @change="
                showMarkers = true;
                showSlider = true;
              "
              tile
              flat
              hide-details
              height="60px"
              color="secondary"
              class="rounded-0"
              item-color="secondary"
              v-model="selectedLocation"
              :items="[
                'iLand Properties - Lekki',
                'Milliard Court - Mowe',
                'Lavida Hills - Alagbado',
              ]"
              label="Select Location"
              solo
            />
          </v-col>
        </v-row>
        <v-sheet height="100%" width="1000" color="secondary">
          <hm-map
            @loadedMarkers="showSlider = true"
            :showMarkers="showMarkers"
          />
        </v-sheet>
        <v-row justify="center">
          <v-dialog
            overlay-opacity="0.8"
            overlay-color="primary"
            v-model="dialog"
            persistent
            max-width="800px"
            content-class="elevation-0"
            transition="scroll-y-transition"
          >
            <div
              class="text-h3 white--text text-center font-weight-regular mb-5"
            >
              Next, We would like you to choose the location of your
              {{ selectionType == "landbank" ? "land" : "house" }}
            </div>
            <div class="d-flex justify-center mt-10">
              <v-btn
                @click="proceed"
                tile
                depressed
                class="text-none py-7"
                color="secondary"
              >
                <span class="mr-2 white--text text-h6">Continue</span>
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </v-dialog>
        </v-row>
      </v-col>
    </v-row>
    <v-card
      flat
      class="mt-auto wall--base"
      height="15vh"
      color="primary"
      width="100vw"
      :style="{
        backgroundImage: `url('${baseImage}')`,
        width: '100vw',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom',
        opacity: '0.81',
      }"
    ></v-card>
    <v-card
      v-if="$vuetify.breakpoint.mdAndUp"
      flat
      class="wall--left"
      height="100vh"
      color="primary"
      :style="{
        backgroundImage: `url('${wallImage}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: '8vw',
        backgroundPosition: 'center bottom',
        opacity: '0.81',
      }"
    ></v-card>
    <v-card
      v-if="$vuetify.breakpoint.mdAndUp"
      flat
      class="wall--right"
      height="100vh"
      color="primary"
      :style="{
        backgroundImage: `url('${wallImage}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: '8vw',
        backgroundPosition: 'center bottom',
        opacity: '0.81',
      }"
    ></v-card>
    <transition name="fade">
      <v-card
        width="100vw"
        height="100vh"
        class="journey-card d-flex"
        v-if="showSlider"
        color="transparent"
        flat
      >
        <v-card
          class="z-index-7 journey-card--item"
          tile
          :width="$vuetify.breakpoint.mdAndUp ? '75vw' : '100vw'"
          height="100vh"
        >
          <v-container class="pt-5">
            <v-row class="px-6 pt-10">
              <v-col cols="12">
                <div class="d-flex justify-space-between align-center">
                  <v-btn
                    color="secondary"
                    depressed
                    @click="$router.push({ name: 'dashboard.index' })"
                    >GO TO DASHBOARD</v-btn
                  >
                  <v-btn
                    icon
                    color="secondary"
                    @click="
                      showSlider = false;
                      showFilters = false;
                    "
                  >
                    <v-icon size="30">mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="blue-grey--text text-body-1 mb-2">Welcome to</div>
                <div class="text-h4 primary--text font-weight-bold">
                  Homify
                  {{ selectionType == "landbank" ? "Landbanks" : "Homes" }}
                </div>
              </v-col>

              <v-col cols="12">
                <component :is="activeComponent" isOnboarding />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card
          :width="$vuetify.breakpoint.mdAndUp ? '25vw' : '100vw'"
          height="100vh"
          class="filter-card"
          v-if="showFilters"
          color="transparent"
          flat
        >
          <v-card
            class="filter-card-item z-index-7"
            tile
            :width="$vuetify.breakpoint.mdAndUp ? '25vw' : '100vw'"
            height="100vh"
            color="primary"
          >
            <v-container>
              <v-row class="px-6 pt-10">
                <v-col cols="12">
                  <div class="d-flex mb-10">
                    <homify-icon-dark />
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="search"
                    placeholder="Search properties..."
                    outlined
                    append-icon="mdi-magnify"
                    color="secondary"
                    dark
                    class="rounded-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <div class="white--text mb-2 text-body-1">Property Type</div>
                </v-col>
                <v-col
                  cols="6"
                  v-for="(propertyType, idx) in propertyTypes"
                  :key="idx"
                >
                  <div
                    depressed
                    :class="{
                      'secondary--border':
                        filterOptions.propertyType != propertyType,
                      secondary: filterOptions.propertyType == propertyType,
                    }"
                    class="py-4 d-block text-center text-none text-capitalize"
                    style="z-index: 17"
                    @click="selectPropertyType(propertyType)"
                  >
                    <div class="white--text d-block">{{ propertyType }}</div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="white--text mb-2 text-body-1 mt-5">
                    Price Range
                  </div>

                  <v-range-slider
                    dark
                    thumb-size="60"
                    :max="50000000000000"
                    :min="100000"
                  ></v-range-slider>
                </v-col>
                <v-col cols="12">
                  <div class="white--text mb-2 text-body-1 mt-5">Location</div>

                  <v-select
                    label="Location"
                    :items="['Lagos State']"
                    solo
                    flat
                    class="rounded-0"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-checkbox
                    class="py-0"
                    dark
                    color="success"
                    v-model="filterOptions.nonFurnished"
                    label="Non-finished"
                  ></v-checkbox>
                  <v-checkbox
                    class="py-0"
                    dark
                    color="success"
                    v-model="filterOptions.furnished"
                    label="Finished"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-card>
      </v-card>
    </transition>
    <transition name="fade"></transition>
  </v-layout>
</template>

<script>
import HmMap from "@/components/map/HmMap";
import MenuIcon from "@/components/icons/MenuIcon.vue";
import HmIcon from "@/components/HmIcon.vue";
import HomeOffers from "@/views/homes/Offers";
import LandbankOffers from "@/views/landbank/Offers";
import HomifyIconDark from "@/assets/svg/homify-logo__light.svg";

export default {
  components: {
    HmMap,
    MenuIcon,
    HmIcon,
    HomeOffers,
    HomifyIconDark,
    LandbankOffers,
  },
  data() {
    return {
      baseImage: require("@/assets/svg/hm-base.png"),
      wallImage: require("@/assets/svg/hm-wall.png"),
      dialog: true,
      showMarkers: false,
      selectedLocation: null,
      showSlider: false,
      showFilters: false,
      search: "",
      filterOptions: {
        propertyType: "",
        priceRange: [],
        furnished: false,
        nonFurnished: false,
      },
      propertyTypes: ["stand-alone", "duplex", "apartment", "commercial"],
    };
  },
  computed: {
    selectionType() {
      return this.$route.query.type;
    },
    activeComponent() {
      let value;
      if (this.selectionType == "homes") {
        value = "home-offers";
      } else if (this.selectionType == "landbank") {
        value = "landbank-offers";
      }

      return value;
    },
  },
  methods: {
    proceed() {
      this.dialog = false;
    },
    selectPropertyType(propertyType) {
      this.filterOptions.propertyType = propertyType;
    },
  },
  mounted() {
    // console.log(this.selectionType)
  },
};
</script>

<style lang="scss" scoped>
.journey-card {
  position: absolute;
  z-index: 13;
  left: 0;

  &--item {
    position: relative;
    left: 0;
    overflow-y: auto;
  }
}

.z-index-7 {
  z-index: 16;
}

.filter-card {
  position: fixed;
  right: 0;
}
.wall {
  &--base {
    position: absolute;
    bottom: 0;
  }

  &--left {
    position: absolute;
    left: 0;
  }

  &--right {
    position: absolute;
    right: 0;
  }
}

.select--field {
  position: absolute;
  top: 20px;
  right: 0;
  left: 0;
  z-index: 12;
}

.home--offers {
  position: absolute;
}

.fade-enter-active,
.fade-leave-active {
  transition: left 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  left: -100%;
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: right 1s;
}
.fadeIn-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  right: -100%;
}
</style>
